import req from '../../api/request'
import type { SnEvent } from '../../features/event/types'

/**
 * The team across EVERY season, plus any competition events it has been named
 * in. Backs the "All Seasons" selection, where there is no single roster to
 * scope to.
 *
 * Like the roster list: no query params, not paginated.
 */
export const listTeamEvents = async (teamId: string): Promise<SnEvent[]> => {
  const response = await req(`/teams/${teamId}/events`)
  // Accept both the documented envelope and a bare array — see listRosterEvents.
  const events = Array.isArray(response) ? response : response?.data
  return (events ?? []) as SnEvent[]
}
